import React, { FunctionComponent } from "react";
import Link from "next/link";

const Disclaimer: FunctionComponent = () => {
  return (
    <div className="mt-2 py-2 text-xs opacity-80">
      By submitting this form, you agree to receive marketing communications
      from SponsorPulse according to the{" "}
      <Link href="/terms-and-conditions">
        <span className="underline">Terms and Conditions</span>
      </Link>{" "}
      and{" "}
      <Link href="/privacy-policy">
        <span className="underline">Privacy Policy</span>
      </Link>
      . You can unsubscribe at any time.
    </div>
  );
};

export default Disclaimer;
